module.exports = __webpack_public_path__ + "img/538.dfa2b6e5.jpg";